import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useConfirmationDialog } from './useConfirmationDialog';

export interface ConfirmationDialogSettings {
  description: string | React.ReactNode;
  handler: (confirm: boolean) => void;
}

export interface ConfirmationDialogProps {
  setConfirmationDialogSettingsRef: React.MutableRefObject<
    ((current: ConfirmationDialogSettings) => void) | undefined
  >;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  setConfirmationDialogSettingsRef,
}) => {
  const { t } = useTranslation();
  const { confirmationDialogSettings, handleCancel, handleConfirm } =
    useConfirmationDialog(setConfirmationDialogSettingsRef);

  const content = confirmationDialogSettings?.description;

  return (
    <Dialog open={!!confirmationDialogSettings} onClose={handleCancel}>
      <DialogTitle>{t('confirm')}</DialogTitle>
      <DialogContent>
        {typeof content === 'string' ? (
          <DialogContentText>{content}</DialogContentText>
        ) : (
          content
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCancel} color="primary" autoFocus>
          {t('no')}
        </Button>
        <Button onClick={handleConfirm} color="primary" data-cy="confirm-yes">
          {t('yes')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
